import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  padding: 30px 60px 30px 60px;
  margin: 20px 0;

  background-color: ${theme.colors.darkBlue};
  border-radius: ${theme.border.mediumRadius} 0 0 ${theme.border.mediumRadius};

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.darkBlue};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0;
    padding-right: 10px;
    background-color: ${theme.colors.blue900};
  }
`;
